<template>
    <select
        :id="name"
        :value="value"
        class="select-input"
        :name="name"
        :aria-label="label"
        @input="$emit('input', $event.target.value)"
    >
        <option value="" disabled>
            {{ label }}
        </option>
        <option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
            >{{ option.name }}</option
        >
    </select>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default() {
                return {};
            }
        },
        name: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        value: {
            type: String,
            default: ''
        },
        multiple: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss">
.select-input {
    padding: 5px 14px;
    color: $brand-gray-dark;
    border: none;
    font-style: italic;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}
</style>
